import { api } from "../../axios";

export const actions = {
    GetActual(){
        return api.get("Actual/GetAllActuals");
    },
    GetSingleActual(context, data){
        return api.get(`Actual/${data}`);
    },
    GetActualByTarget(context, data){
        return api.get(`Actual/target/${data}`);
    },
    UpdateActual(context, data){
        return api.put(`Actual/${data.id}`, data);
    },
    PostActual(context, data){
        return api.post(`Actual/Post/${data}`);
    },
    UnpostActual(context, data){
        return api.put(`Actual/Return/${data.id}`, data);
    },
    PostActualByQuarter(context, data){
        return api.put(`Actual/Post/${data.id}/${data.quarter}`);
    },
    UnpostActualByQuarter(context, data){
        return api.put(`Actual/Return/${data.id}/${data.quarter}`, data);
    },
    DeleteActual(context, data){
        return api.delete(`Actual/${data}`);
    },
    CreateActual(context, data){
        return api.post(`Actual/CreateActual`, data);
    },
}